/* Olilu basket: the drawer (sections/basket-drawer.liquid) and the /cart page (sections/basket-page.liquid).
   Both are built from snippets/basket-lines.liquid. On every document 'olilu:cart' event each one renders its own
   section again (Section Rendering API) and swaps only its [data-bk-swap] regions, so the gift note, the express
   checkout buttons and the scroll position stay where they are. Both sections load this file; it runs once. */
(function () {
  'use strict';
  if (window.__oliluBasket) return;
  window.__oliluBasket = true;

  var O = window.Olilu;
  if (!O) return;
  var routes = (O.cfg && O.cfg.routes) || {};
  var CART_URL = routes.cart || '/cart';
  var ROOTS = '[data-basket-drawer], [data-basket-page]';
  var NOTE_MAX = 200;
  var MSG_STOCK = "Sorry, we don't have any more of these.";
  var MSG_FAIL = "Sorry, that didn't work. Please try again.";

  // Shopify gives a line a new key whenever its discount changes (every step across the set saving), so lines are
  // tracked by variant id ([data-bk-variant]) and the key is looked up fresh just before each request.
  var pending = {};      // variant id -> timer for a quantity change not yet sent
  var inflight = 0;      // quantity changes on their way to Shopify
  var chain = Promise.resolve();
  var deferred = null;   // the latest 'olilu:cart' detail that arrived while quantities were changing
  var forceNext = false; // render again even if the cart looks unchanged (after an error)
  var errors = {};       // variant id -> message shown on that line after the next render
  var spoken = '';       // what to announce once the next render lands

  /* ---------- Helpers ---------- */
  function roots() { return O.$$(ROOTS); }
  function drawerEl() { return document.getElementById('BasketDrawer'); }
  function isDrawer(root) { return root.hasAttribute('data-basket-drawer'); }
  function busy() { return inflight > 0 || Object.keys(pending).length > 0; }
  function matches(el, sel) { return !!(el && el.nodeType === 1 && el.matches(sel)); }

  // Same string as part 'sig' in snippets/basket-lines.liquid
  function sig(cart) {
    return cart.item_count + '|' + cart.total_price + '|' + (cart.items || []).map(function (i) {
      return i.key + 'x' + i.quantity;
    }).join(';');
  }
  function byAttr(root, attr, value) {
    return O.$$('[' + attr + ']', root).filter(function (n) { return n.getAttribute(attr) === value; })[0] || null;
  }
  function liveRoot() {
    var d = drawerEl();
    if (d && d.classList.contains('is-open')) return d;
    return O.$('[data-basket-page]') || d;
  }
  function announce(text) {
    var root = liveRoot();
    var live = root && O.$('[data-bk-live]', root);
    if (!live || !text) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 60);
  }
  function errorText(err) {
    return err && err.data && Number(err.data.status) === 422 ? MSG_STOCK : MSG_FAIL;
  }
  function itemFor(cart, variant) {
    return ((cart && cart.items) || []).filter(function (i) { return String(i.variant_id) === String(variant); })[0] || null;
  }

  /* ---------- Rendering ---------- */
  function refresh(root, cart, force) {
    if (!force && cart && (root.getAttribute('data-sig') || '').trim() === sig(cart)) return Promise.resolve(false);
    root.setAttribute('aria-busy', 'true');
    return O.section(CART_URL, root.getAttribute('data-section-id'))
      .then(function (html) {
        var fresh = O.parse(html).querySelector(isDrawer(root) ? '[data-basket-drawer]' : '[data-basket-page]');
        if (!fresh) return false;
        swap(root, fresh);
        return true;
      })
      .catch(function () { return false; })
      .then(function (done) {
        root.removeAttribute('aria-busy');
        return done;
      });
  }

  function swap(root, fresh) {
    var active = document.activeElement;
    var hadFocus = !!(active && active !== document.body && root.contains(active));
    var focusId = hadFocus ? active.getAttribute('data-bk-focus') : null;

    O.$$('[data-bk-swap]', root).forEach(function (old) {
      var next = byAttr(fresh, 'data-bk-swap', old.getAttribute('data-bk-swap'));
      if (next) old.replaceWith(document.importNode(next, true));
    });

    var count = fresh.getAttribute('data-count') || '0';
    root.setAttribute('data-count', count);
    root.setAttribute('data-sig', (fresh.getAttribute('data-sig') || '').trim());
    O.$$('[data-bk-when-items]', root).forEach(function (el) { el.hidden = count === '0'; });

    Object.keys(errors).forEach(function (variant) {
      var line = byAttr(root, 'data-bk-variant', variant);
      var msg = line && O.$('[data-bk-msg]', line);
      if (msg) { msg.textContent = errors[variant]; msg.hidden = false; }
    });

    // Keep focus where it was: the same control on the same line, else the basket heading
    if (hadFocus && !root.contains(document.activeElement)) {
      var target = (focusId && byAttr(root, 'data-bk-focus', focusId)) || O.$('[data-bk-focus-fallback]', root);
      if (target) target.focus({ preventScroll: true });
    }
  }

  function render(detail, force) {
    detail = detail || {};
    return Promise.all(roots().map(function (root) { return refresh(root, detail.cart, force); }))
      .then(function () {
        if (Object.keys(errors).length) announce(errors[Object.keys(errors)[0]]);
        errors = {};
        O.$$('.bk-line.is-busy').forEach(function (l) { l.classList.remove('is-busy'); });
        if (detail.added && detail.added.length) showAdded(detail.added);
        else if (spoken) announce(spoken);
        spoken = '';
      });
  }

  /* ---------- "Added: Heather Cable Knit Alpaca Fingerless Gloves" ---------- */
  var addedTimer, fadeTimer;
  function addedMessage(added) {
    var root = drawerEl() || O.$('[data-basket-page]');
    var parts = added.map(function (a) {
      var line = root && (byAttr(root, 'data-bk-line', a.key) || byAttr(root, 'data-bk-variant', String(a.variant_id || a.id)));
      return {
        colour: line ? line.getAttribute('data-colour') || '' : '',
        design: line ? line.getAttribute('data-design') || '' : (a.product_title || a.title || '')
      };
    });
    var uniq = function (v, i, all) { return v && all.indexOf(v) === i; };
    var designs = parts.map(function (p) { return p.design; }).filter(uniq);
    var colours = parts.map(function (p) { return p.colour; }).filter(uniq);
    if (parts.length === 1) return [parts[0].colour, parts[0].design].filter(Boolean).join(' ');
    if (designs.length === 1 && colours.length === parts.length) {
      return (colours.length > 1 ? colours.slice(0, -1).join(', ') + ' and ' + colours[colours.length - 1] : colours[0]) + ' ' + designs[0];
    }
    return parts.length + ' pieces';
  }
  function showAdded(added) {
    var text = 'Added: ' + addedMessage(added);
    announce(text);
    var d = drawerEl();
    var box = d && O.$('[data-bk-added]', d);
    var label = box && O.$('[data-bk-added-text]', box);
    if (!label) return;
    label.textContent = text;
    box.classList.remove('is-fading');
    box.hidden = false;
    clearTimeout(addedTimer);
    clearTimeout(fadeTimer);
    addedTimer = setTimeout(function () {
      box.classList.add('is-fading');
      fadeTimer = setTimeout(function () { box.hidden = true; box.classList.remove('is-fading'); }, 400);
    }, 4000);
  }

  /* ---------- Cart changes from anywhere ---------- */
  document.addEventListener('olilu:cart', function (e) {
    var d = e.detail || {};
    if (busy()) {
      deferred = { cart: d.cart, added: d.added || (deferred && deferred.added) || null };
      return;
    }
    render(d);
  });

  function flush() {
    var d = deferred, force = forceNext;
    deferred = null;
    forceNext = false;
    if (!d && !force) {
      O.$$('.bk-line.is-busy').forEach(function (l) { l.classList.remove('is-busy'); });
      return;
    }
    render(d || {}, force);
  }

  /* ---------- Quantities: "− 1 +", typed numbers and Remove ---------- */
  function setQuantity(line, qty, now) {
    var variant = line.getAttribute('data-bk-variant');
    var key = line.getAttribute('data-bk-line');
    qty = Math.max(0, Math.min(999, Math.floor(qty) || 0));
    // The same line may be on screen twice (drawer and /cart page)
    O.$$('[data-bk-variant]').forEach(function (l) {
      if (l.getAttribute('data-bk-variant') !== variant) return;
      var input = O.$('[data-bk-qty]', l);
      if (input) input.value = qty;
      var msg = O.$('[data-bk-msg]', l);
      if (msg) { msg.hidden = true; msg.textContent = ''; }
      l.classList.add('is-busy');
    });
    clearTimeout(pending[variant]);
    pending[variant] = setTimeout(function () {
      delete pending[variant];
      send(variant, key, qty);
    }, now ? 0 : 350);
  }

  function send(variant, key, qty) {
    inflight++;
    chain = chain
      .then(function () {
        // An earlier change in this chain may have re-keyed the line: prefer the key from the latest cart
        var live = itemFor(O.cart.last, variant);
        return O.cart.change(live ? live.key : key, qty)
          .catch(function (err) {
            // Out of stock is final; anything else (usually a stale key) gets one retry with a fresh key
            if (err && err.data && Number(err.data.status) === 422) throw err;
            return O.cart.get().then(function (cart) {
              var item = itemFor(cart, variant);
              if (!item) throw err;
              return O.cart.change(item.key, qty);
            });
          })
          .then(function (cart) {
            var item = itemFor(cart, variant);
            if (qty > 0 && item && item.quantity < qty) { errors[variant] = MSG_STOCK; forceNext = true; }
            spoken = qty === 0 ? 'Removed. Subtotal ' + O.money(cart.total_price) + '.' : 'Basket updated. Subtotal ' + O.money(cart.total_price) + '.';
          }, function (err) {
            errors[variant] = errorText(err);
            forceNext = true;
          });
      })
      .then(function () {
        inflight--;
        if (!busy()) flush();
      });
  }

  /* ---------- Suggestion and gift box: "Add" ---------- */
  function addFrom(btn) {
    var id = btn.value;
    if (!id) {
      var box = btn.closest('[data-bk-suggest]');
      var picked = box && O.$('[data-bk-sib]:checked', box);
      id = picked && picked.value;
    }
    if (!id || btn.classList.contains('is-loading')) return;
    var row = btn.closest('[data-bk-suggest], .bk-giftbox');
    var old = row && O.$('.bk-suggest__msg', row);
    if (old) old.remove();
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    O.cart.add([{ id: Number(id), quantity: 1 }]).catch(function (err) {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      var text = errorText(err);
      if (row) {
        var p = document.createElement('p');
        p.className = 'bk-line__msg bk-suggest__msg';
        p.textContent = text;
        row.appendChild(p);
      }
      announce(text);
    });
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.bk-gift > summary');
    if (summary) {
      var details = summary.parentNode;
      setTimeout(function () {
        var field = details.open && O.$('[data-bk-note]', details);
        if (field) field.focus();
      }, 0);
      return;
    }
    var t = e.target.closest('[data-bk-step], [data-bk-remove], [data-bk-add]');
    if (!t || !t.closest(ROOTS)) return;
    if (t.hasAttribute('data-bk-add')) {
      e.preventDefault();
      addFrom(t);
      return;
    }
    var line = t.closest('[data-bk-line]');
    if (!line) return;
    e.preventDefault();
    if (t.hasAttribute('data-bk-remove')) {
      setQuantity(line, 0, true);
      return;
    }
    var input = O.$('[data-bk-qty]', line);
    var current = parseInt(input && input.value, 10) || 0;
    setQuantity(line, current + Number(t.getAttribute('data-bk-step')), false);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (matches(t, '[data-bk-qty]')) {
      var line = t.closest('[data-bk-line]');
      if (!line || !t.closest(ROOTS)) return;
      var variant = line.getAttribute('data-bk-variant');
      var server = Number(line.getAttribute('data-qty')) || 0;
      var q = parseInt(t.value, 10);
      if (isNaN(q)) q = server;
      if (q === server && !pending[variant]) { t.value = q; return; }
      setQuantity(line, q, true);
    } else if (matches(t, '[data-bk-sib]')) {
      var box = t.closest('[data-bk-suggest]');
      var name = box && O.$('[data-bk-pick-name]', box);
      var price = box && O.$('[data-bk-pick-price]', box);
      if (name) name.textContent = t.getAttribute('data-name') || '';
      if (price) price.textContent = t.getAttribute('data-price') || '';
    }
  });

  // Enter in a quantity box applies it here instead of submitting the form
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !matches(e.target, '[data-bk-qty]')) return;
    e.preventDefault();
    e.target.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Gift note: saved as the cart attribute "Gift note" ---------- */
  function noteStatus(text) {
    O.$$('[data-bk-note-status]').forEach(function (s) { s.textContent = text; });
  }
  var saveNote = O.debounce(function (value) {
    O.cart.update({ attributes: { 'Gift note': value } }).then(function () {
      noteStatus('Saved');
    }, function () {
      noteStatus('Not saved yet. It will go with your order when you check out.');
    });
  }, 700);
  document.addEventListener('input', function (e) {
    var field = e.target;
    if (!matches(field, '[data-bk-note]')) return;
    var value = field.value.slice(0, NOTE_MAX);
    O.$$('[data-bk-note]').forEach(function (other) { if (other !== field) other.value = value; });
    O.$$('[data-bk-note-left]').forEach(function (n) { n.textContent = String(NOTE_MAX - value.length); });
    noteStatus('');
    saveNote(value);
  });

  /* ---------- Opening the drawer ---------- */
  document.addEventListener('olilu:basket-open', function (e) {
    var el = drawerEl();
    if (!el) { location.href = CART_URL; return; }
    O.drawer.open(el, e.detail && e.detail.opener);
  });

  // Back/forward cache: the basket may have changed on another page
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || !roots().length) return;
    O.cart.get().then(function (cart) { O.cart.last = cart; render({ cart: cart }); }).catch(function () {});
  });

  /* ---------- Theme editor ---------- */
  // Olilu.drawer.open moves the drawer to <body>; after a section reload drop the old copy
  O.ready('[data-basket-drawer]', function (el) {
    O.$$('#BasketDrawer').forEach(function (other) {
      if (other === el) return;
      if (other.classList.contains('is-open')) O.drawer.close(other);
      other.remove();
    });
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.detail && e.detail.sectionId === 'basket-drawer' && drawerEl()) O.drawer.open(drawerEl());
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.detail && e.detail.sectionId === 'basket-drawer' && drawerEl()) O.drawer.close(drawerEl());
  });
})();
